import { InjectionToken } from '@angular/core';

export interface TooltipConfig {
  triggers?: string;
  closeDelay?: number;
  openDelay?: number;
}

export const TOOLTIP_CONFIG_TOKEN = new InjectionToken<TooltipConfig>('TOOLTIP_CONFIG_TOKEN');
